<div id="main-wrap" class="main-wrap main-wrap__scrollable">
  <div class="page-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>

@if (!router.url.includes('admin')) {
  <app-message-toast></app-message-toast>
}
